type Keys<T> = T extends object
    ? {
          [K in keyof T]: `${Exclude<K, symbol>}${Keys<T[K]> extends never ? '' : `.${Keys<T[K]>}`}`;
      }[keyof T]
    : never;

type Values<T> = T extends object
    ? {
          [K in keyof T]: T[K] extends object ? Values<T[K]> : T[K];
      }[keyof T]
    : never;

function getAllNestedValuesInner<T extends object>(
    object: T,
    parent?: string,
): Array<{ key: Keys<T>; value: Values<T> }> {
    return Object.entries(object)
        .map(([innerKey, value]) => {
            const key = parent ? `${parent}.${innerKey}` : innerKey;

            if (typeof value === 'object') {
                const objectNested = getAllNestedValuesInner(value, key);
                return objectNested;
            }
            return [{ key, value }];
        })
        .flat() as Array<{ key: Keys<T>; value: Values<T> }>;
}

/**
 * Gets all the nested key paths and values in an object
 *
 * @param object - The object
 * @returns An array with all the nested keys and values
 */
export function getAllNestedValues<T extends object>(object: T): Array<{ key: Keys<T>; value: Values<T> }> {
    return getAllNestedValuesInner(object);
}
